import { FilterType, getFilteredTabId, } from '@office-start/base-edgeworth-control';
export function populateClickParamsWithFilters(clickParams, filterModels) {
    if (filterModels) {
        filterModels.forEach(function (filterModel) {
            var param;
            switch (filterModel.filterType) {
                case FilterType.Activity:
                    param = "ActivityFilters" /* InstrumentationParam.ActivityFilters */;
                    break;
                case FilterType.Date:
                    param = "DateFilters" /* InstrumentationParam.DateFilters */;
                    break;
                case FilterType.FileType:
                    // TODO: Pill was used for EW mobile
                    // case FilterType.Pill:
                    param = "AppFilters" /* InstrumentationParam.AppFilters */;
                    break;
                case FilterType.SharedBy:
                    param = "SharedFilters" /* InstrumentationParam.SharedFilters */;
                    break;
                case FilterType.Tabs:
                    param = "TabState" /* InstrumentationParam.TabState */;
                    break;
            }
            if (param) {
                var filteredTabId = filterModel.customFilterType
                    ? getFilteredTabId(filterModel.filterId)
                    : filterModel.filterId;
                clickParams[param] = "".concat(clickParams[param] ? clickParams[param] + ',' : '').concat(filteredTabId);
            }
        });
    }
}
//# sourceMappingURL=populateClickParamsWithFilters.js.map